import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import DropBoxDataRepostory from '../../../../data/repositories/DropBoxDataRepository';
import DropBoxRepository from '../../../repositories/DropBoxRepository';

export default function* execute(payload: any): any {
  try {
    const { path, token } = payload;
    yield put({ type: Types.GET_URL_DOCUMENT_REQUEST });
    const repository: DropBoxRepository = new DropBoxDataRepostory();

    const response = yield call(repository.generateUrlDocument, path, token);

    if (!response) {
      yield put({
        type: Types.GET_URL_DOCUMENT_FAILURE,
        error: true
      });
      return;
    }

    yield put({
      type: Types.GET_URL_DOCUMENT_SUCCESS,
      data: response
    });
  } catch (error) {
    yield put({
      type: Types.GET_URL_DOCUMENT_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
